import { MagentoSalesOrder } from './magento-sales-order';

export interface MagentoSalesOrders {
  items: MagentoSalesOrder[];
  searchCriteria: any;
  totalCount: number;
}
